import React, { useState, useEffect } from "react";
import { useStateValue } from "../../../State";
import "../combinedplan.css";
import Moment from "moment";

import ContentBoxMUI from "../../../Components/ContentBoxMUI";
import Languages from "../../../translations";
import ChildRow from "../../Vasu/ChildRow";
import SupportDetailView from "./SupportDetailView";
import CombinedPlanLeopsSupport from "./CombinedPlanLeopsSupport";
import ApprovalsComponent from "../../Vasu/Approvals";
import DownloadFileButton from "../../../Components/DownloadFileButton/DownloadFileButton";
import SnackbarComponent from "../../../Components/Snackbar";
import { getProfilePictureData } from "../../../utils";
import { types } from "../../../Reducers/actionTypes";
import { getCombinedPlanSectionTitle } from "../sectionTitles";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CheckBoxTwoToneIcon from "@mui/icons-material/CheckBoxTwoTone";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const SupportTiersPart = (props) => {
  const { state, actions } = useStateValue();
  const combinedPlanData = state.combinedPlan.data;
  const approvalSaveState = state.combinedPlan.approvalSaveState;
  const SupportTiers = combinedPlanData ? combinedPlanData.SupportTiers : null;

  const { history, match } = props;
  const childId = match.params.ChildId;
  const child = state.children?.ChildList?.find((c) => c.Id === childId);
  const childpicture = getProfilePictureData(state, child?.Id);
  const childFirstName = child?.FirstName ?? null;
  const childLastName = child?.LastName ?? null;
  const childColor = child?.BgColor ?? null;
  const sectionTitle = getCombinedPlanSectionTitle(
    combinedPlanData,
    "support",
    combinedPlanData?.SupportSectionTitle,
  );

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  const [selectedTier, setSelectedTier] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [SavingData, setSavingData] = useState(false);
  const [showSnackbar, setshowSnackbar] = useState(false);
  const [NoteText, setNoteText] = useState(null);

  useEffect(() => {
    if (!combinedPlanData) {
      history.replace(`/combinedplan/${childId}`);
    }
  }, []);

  useEffect(() => {
    switch (approvalSaveState) {
      case undefined:
        break;
      case types.SAVING_COMBINED_PLAN_APPROVAL:
        setSavingData(true);
        break;
      case types.COMBINED_PLAN_APPROVAL_SAVED_OK:
        setSavingData(false);
        setshowSnackbar(true);
        setNoteText("Hyväksynnän tallennus ok");
        break;
      case types.COMBINED_PLAN_APPROVAL_SAVED_FAILED:
        setSavingData(false);
        setshowSnackbar(true);
        setNoteText(Languages.requestFailed);
        break;
      default:
        break;
    }
  }, [approvalSaveState]);

  const handleSnackbarCB = () => {
    actions.triggerCombinedPlanApprovalHandled();
    setshowSnackbar(false);
  };

  const handleApprovalSave = (approvalData) => {
    actions.triggerSaveCombinedPlanApproval(approvalData);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleBackClick = () => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      window.history.pushState(null, "", window.location.href);
      setSelectedTier(null);
      window.onpopstate = undefined;
      window.history.back();
    };
  };

  const handleTierClick = (tier) => {
    setSelectedTier(tier);
    handleBackClick();
  };

  if (!combinedPlanData || !SupportTiers) {
    return <div className="CombinedPlanContainer"></div>;
  }

  const { GeneralSupport, EnhancedSupport, SpecialSupport } = SupportTiers;

  const hasLeops = child?.LeopsId != null;

  const formatDate = (date) => (date ? Moment(date).format("DD.MM.YYYY") : "");

  // Build the status string mirroring Vasu's handleString()
  const supportString = (support, titleText, hasDecision) => {
    if (!support || !support.StartDate) return "";
    let str =
      titleText +
      " " +
      formatDate(support.StartDate) +
      " - " +
      formatDate(support.EndDate) +
      " ";
    if (hasDecision && support.DecisionDate) {
      str +=
        Languages.VasuadministrativeDecision +
        " " +
        formatDate(support.DecisionDate);
    } else if (!hasDecision) {
      str += Languages.VasuNoadministrativeDecision;
    }
    return str;
  };

  // GeneralPart-shaped object for the reused ApprovalsComponent
  const generalPartLike = {
    Parent1Id: combinedPlanData.Guardian1PersonId,
    Parent2Id: combinedPlanData.Guardian2PersonId,
    Parent1Name: combinedPlanData.Guardian1Name,
    Parent2Name: combinedPlanData.Guardian2Name,
    ParentId: combinedPlanData.UserPersonId,
  };

  const renderSupportTier = (support, titleText, tierKey, panelId) => {
    const active = support && support.StartDate != null;
    if (!active) return null;
    const hasDecision =
      support && support.DecisionPersonAttachmentId != null ? true : false;

    return (
      <Stack spacing={1} alignItems="center" sx={{ mt: 4 }}>
        <Stack direction="row" spacing={1} alignItems="baseline">
          {active && (
            <CheckBoxTwoToneIcon
              sx={{ color: "green", fontSize: 16, fontWeight: "medium" }}
            />
          )}
          <Typography
            color="textSecondary"
            sx={{
              textAlign: "left",
              fontWeight: "medium",
              fontSize: 16,
              color: "#424242",
            }}
          >
            {supportString(support, titleText, hasDecision)}
          </Typography>
          {active && hasDecision && (
            <DownloadFileButton
              FileName={support.DecisionFileName}
              FileMimeType={support.DecisionFileType}
              FileId={support.DecisionPersonAttachmentId}
              file={null}
              useIconButton={false}
              useThreeDots={false}
              useTextButton={true}
              disabled={false}
              text={Languages.generalOpen}
              isImage={false}
            />
          )}
        </Stack>

        <List className="col-12">
          <ListItemButton
            className="boxed"
            sx={{ backgroundColor: "#fceebf", borderRadius: 0.5, boxShadow: 2 }}
            onClick={() => handleTierClick(tierKey)}
          >
            <ListItemText
              primaryTypographyProps={{
                fontWeight: "Bold",
                fontSize: 16,
                ml: 2,
              }}
              primary={titleText}
            />
            <ListItemIcon>
              <ArrowForwardIosIcon fontSize="small" />
            </ListItemIcon>
          </ListItemButton>
        </List>

        {hasDecision && (
          <Box className="col-12">
            <Accordion
              expanded={expanded === panelId}
              onChange={handleChange(panelId)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                style={{ backgroundColor: "#fceebf" }}
                aria-controls={panelId + "-content"}
                id={panelId + "-header"}
              >
                <Typography
                  color="textSecondary"
                  sx={{
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: 16,
                    color: "#424242",
                  }}
                >
                  {Languages.ConsultationChildAndGuardian2}
                </Typography>
              </AccordionSummary>
              <AccordionDetails style={{ backgroundColor: "#ffffff" }}>
                <Stack
                  className="col-12"
                  direction={isDesktop ? "row" : "column"}
                  spacing={8}
                  alignItems={isDesktop ? "flex-start" : "center"}
                  sx={[isDesktop ? { mt: 2, ml: 4 } : { mt: 2 }]}
                >
                  <ApprovalsComponent
                    Approval={support.Guardian1Approval}
                    GeneralPart={generalPartLike}
                    ParentName={combinedPlanData.Guardian1Name}
                    ParentId={combinedPlanData.Guardian1PersonId}
                    DecisionId={support.DecisionPersonAttachmentId}
                    Type={0}
                    PlanId={combinedPlanData.PlanId}
                    onSave={handleApprovalSave}
                  />
                  <ApprovalsComponent
                    Approval={support.Guardian2Approval}
                    GeneralPart={generalPartLike}
                    ParentName={combinedPlanData.Guardian2Name}
                    ParentId={combinedPlanData.Guardian2PersonId}
                    DecisionId={support.DecisionPersonAttachmentId}
                    Type={0}
                    PlanId={combinedPlanData.PlanId}
                    onSave={handleApprovalSave}
                  />
                </Stack>
              </AccordionDetails>
            </Accordion>
          </Box>
        )}
      </Stack>
    );
  };

  return (
    <div className="CombinedPlanContainer">
      {SavingData && (
        <Backdrop open={true} style={{ color: "#fff", zIndex: 1300 }}>
          <CircularProgress />
        </Backdrop>
      )}
      <ContentBoxMUI>
        <Box sx={{ mt: 1 }}>
          <ChildRow
            childpicture={childpicture}
            childFirstName={childFirstName}
            childLastName={childLastName}
            childColor={childColor}
            FormId={combinedPlanData.PlanId}
            history={history}
          />
        </Box>

        {selectedTier === null ? (
          <div>
            <h4 className="textCenter">{sectionTitle}</h4>

            {/* General support - read-only status line, only shown when active */}
            {GeneralSupport && GeneralSupport.StartDate != null && (
              <Stack spacing={1} alignItems="center" sx={{ mt: 2 }}>
                <Stack direction="row" spacing={1} alignItems="baseline">
                  <CheckBoxTwoToneIcon
                    sx={{
                      color: "green",
                      fontSize: 16,
                      fontWeight: "medium",
                    }}
                  />
                  <Typography
                    color="textSecondary"
                    sx={{
                      textAlign: "left",
                      fontWeight: "medium",
                      fontSize: 16,
                      color: "#424242",
                    }}
                  >
                    {supportString(
                      GeneralSupport,
                      GeneralSupport.Title,
                      GeneralSupport.DecisionPersonAttachmentId != null,
                    )}
                  </Typography>
                </Stack>
              </Stack>
            )}

            {EnhancedSupport &&
              renderSupportTier(
                EnhancedSupport,
                Languages.VasuEnhancedSupport,
                "enhanced",
                "panel1",
              )}

            {SpecialSupport &&
              renderSupportTier(
                SpecialSupport,
                Languages.VasuSpecialSupport,
                "special",
                "panel2",
              )}

            {/* Leops Support - only shown when child has a leops */}
            {hasLeops && (
              <Stack spacing={1} alignItems="center" sx={{ mt: 4 }}>
                <List className="col-12">
                  <ListItemButton
                    className="boxed"
                    sx={{
                      backgroundColor: "#ECEAE5",
                      borderRadius: 0.5,
                      boxShadow: 2,
                    }}
                    onClick={() => handleTierClick("leops")}
                  >
                    <ListItemText
                      primaryTypographyProps={{
                        fontWeight: "Bold",
                        fontSize: 16,
                        ml: 2,
                      }}
                      primary={Languages.ChildSupportPlan}
                    />
                    <ListItemIcon>
                      <ArrowForwardIosIcon fontSize="small" />
                    </ListItemIcon>
                  </ListItemButton>
                </List>
              </Stack>
            )}
          </div>
        ) : selectedTier === "leops" ? (
          <CombinedPlanLeopsSupport child={child} history={history} />
        ) : (
          <SupportDetailView tier={selectedTier} />
        )}

        {showSnackbar && (
          <SnackbarComponent
            verticalPosition={"bottom"}
            show={showSnackbar}
            okColor={true}
            message={NoteText}
            callback={() => handleSnackbarCB()}
          />
        )}
      </ContentBoxMUI>
    </div>
  );
};

export default SupportTiersPart;
